import React from "react";
import {
    MDBRow,
    MDBCol,
    MDBBtn,
    MDBContainer,
    MDBSelect, MDBTableHead, MDBTable, MDBTableBody, MDBIcon, MDBSpinner
} from "mdbreact";
import firebase from "../../../firebase";

class PreviewCompany extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            companyid: null,
            orgData: [],
            companyData: {},
            loading: false
        }
    }

    componentDidMount() {
        this.setupCompanyData();
    }

    setupCompanyData = async () => {
        this.setState({loading: true});
        let companyRef =  this.props.db.collection('company').doc(this.props.id);
        let getDoc = companyRef.get()
            .then(doc => {
                if (!doc.exists) {
                    console.log('No such company document!')
                } else {
                        let data = {};
                        data = doc.data();
                        data.id = doc.id;
                        this.setOrgData(data.id);
                        this.setState({
                            companyData: data,
                            id : data.id
                        })
                    this.setState({loading: false})
                }
            })
            .catch(err => {
                this.setState({loading: false});
                console.log('Error getting company document', err)
            })
    }
    setOrgData = (id) => {
        let orgRef = this.props.db.collection('organizations').where('company', '==', id);
        let getDoc = orgRef.get()
            .then(snapshot => {
                if(snapshot.docs.length > 0) {
                    let orgs = [];
                    snapshot.forEach((doc) => {
                        let data = doc.data();
                        data.id = doc.id;
                        orgs.push(data)
                    })
                    this.setState({orgData: orgs})
                }
            })
            .catch(err => {
                console.log('Error getting organization document', err)
            })
    }
    navigateToEditCompany = () => {
        this.props.cProps.history.push('/company/edit/'+ this.state.id);
        //window.open("/orgList/edit/" + row.id, "_blank");
    }
    render() {

        return (
            <>
                {
                    this.props.user && this.props.user.admin &&
                    <MDBContainer>
                        {this.state.loading && <div className="d-flex justify-content-center mt-5"><MDBSpinner/></div>}
                        <MDBRow>
                            <MDBCol md="12" className="mb-3">
                                <div style={{display:'flex',justifyContent:'space-between',flexDirection:'row',alignItems:'center'}}>
                                    <h2>{this.state.companyData.name}</h2>
                                    <MDBBtn
                                        color="default"
                                        type="submit"
                                        onClick={this.navigateToEditCompany}
                                    >企業情報編集</MDBBtn>
                                </div>

                                <div style={{
                                    height: 30, justifyContent: 'flex-start', padding: 5, paddingLeft: 10,
                                    alignItems: "center", backgroundColor: '#2E75B6', color: 'white'
                                }}>企業情報
                                </div>
                                <form>
                                    <div style={{margin: 10}}>
                                        <label style={{width: 150}}>企業ID</label>
                                        <label style={{flex: 1}}>{this.state.companyData.id}</label>
                                    </div>
                                    <div style={{margin: 10}}>
                                        <label style={{width: 150}}>会社名</label>
                                        <label style={{flex: 1}}>{this.state.companyData.name}</label>
                                    </div>
                                    <div style={{margin: 10}}>
                                        <label style={{width: 150}}>会社名かな</label>
                                        <label style={{flex: 1}}>{this.state.companyData.kana}</label>
                                    </div>
                                    <div style={{margin: 10}}>
                                        <label style={{width: 150}}>郵便番号</label>
                                        <label style={{flex: 1}}>{this.state.companyData.zipcode}</label>
                                    </div>
                                    <div style={{margin: 10}}>
                                        <label style={{width: 150}}>住所</label>
                                        <label style={{flex: 1}}>{this.state.companyData.address}</label>
                                    </div>
                                    <div style={{margin: 10}}>
                                        <label style={{width: 150}}>TEL</label>
                                        <label style={{flex: 1}}>{this.state.companyData.TEL}</label>
                                    </div>
                                    <div style={{margin: 10}}>
                                        <label style={{width: 150}}>FAX</label>
                                        <label style={{flex: 1}}>{this.state.companyData.FAX}</label>
                                    </div>
                                    <div style={{margin: 10}}>
                                        <label style={{width: 150}}>法人番号</label>
                                        <label style={{flex: 1}}>{this.state.companyData['法人番号']}</label>
                                    </div>
                                </form>


                                <div style={{
                                    height: 30, justifyContent: 'flex-start', padding: 5, paddingLeft: 10,
                                    alignItems: "center", backgroundColor: '#2E75B6', color: 'white', marginBottom: 10
                                }}>事業所情報
                                </div>
                                <MDBTable responsive small>
                                    <MDBTableHead style={{backgroundColor: '#EEEEEE'}}>
                                        <tr style={{color: '#212529'}}>
                                            <th style={{paddingLeft: '10px'}}>U種別</th>
                                            <th style={{textAlign: 'left'}}>事業所ID</th>
                                            <th style={{textAlign: 'left'}}>事業所名</th>
                                            <th style={{textAlign: 'left'}}>郵便番号</th>
                                            <th style={{textAlign: 'left'}}>住所</th>
                                            <th style={{textAlign: 'left'}}>TEL</th>
                                            <th style={{textAlign: 'left'}}>FAX</th>
                                            <th style={{textAlign: 'left'}}>支払方法</th>
                                            <th style={{textAlign: 'left'}}>支払日</th>
                                            <th style={{textAlign: 'left'}}>締日</th>
                                        </tr>
                                    </MDBTableHead>
                                    <MDBTableBody>
                                        {
                                            this.state.orgData.map((org) => (
                                                <tr key={org.id} style={{width: '100%'}}>
                                                    <td style={{paddingLeft: '10px'}}>
                                                        <a>{org.buyer ? '購入U' : (org.reseller ? '販社U' : org.maker && 'メーカーU')}</a>
                                                    </td>
                                                    <td>
                                                        <a>{org.id}</a>
                                                    </td>
                                                    <td>
                                                        <a>{org.name}</a>
                                                    </td>
                                                    <td>
                                                        <a>{org.zipcode}</a>
                                                    </td>
                                                    <td>
                                                        <a>{org.address}</a>
                                                    </td>
                                                    <td>
                                                        <a>{org['TEL']}</a>
                                                    </td>
                                                    <td>
                                                        <a>{org['FAX']}</a>
                                                    </td>
                                                    <td>
                                                        <a>{org.paymentMethod || ''}</a>
                                                    </td>
                                                    <td>
                                                        <a>{org['paymentCheck'] && org['paymentDate'] ? org['paymentCheck'] + org['paymentDate'] + '日' : ''}</a>
                                                    </td>
                                                    <td>
                                                        <a>{org['closingDate'] ? '毎月' + org['closingDate'] + '日' : ''}</a>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </MDBTableBody>
                                </MDBTable>

                            </MDBCol>
                        </MDBRow>
                        <div style={{flexDirection: 'row', justifyContent: 'center', display: 'flex'}}>
                            <MDBBtn onClick={() => this.props.cProps.history.push('/orgList')}>一覧に戻る</MDBBtn>
                        </div>
                    </MDBContainer>
                }
            </>
        )
    }
}

export default PreviewCompany;
